var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'uuid/v4'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/uuid/v4.js' implicitly has an 'any' type.
import uuid from "uuid/v4";
import SearchField from "../../../Form/SearchField";
import { StageSearch } from "../../Stage/StageSearch";
import StageService from "../../../../Services/Stage.service";
export const CHANGE_STAGE_GET_CRITERIA = (formState, { exportNodeId, pipelineId }) => {
    const OPPORTUNITY_LOADER_DELEGATE_ID = uuid();
    const opportunityLoaderDelegate = {
        id: OPPORTUNITY_LOADER_DELEGATE_ID,
        type: "OpportunityLoader",
        criteria: {
            subjectId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
            pipelineId: {
                isReference: false,
                value: pipelineId,
            },
        },
    };
    return {
        delegates: [opportunityLoaderDelegate],
        criteria: {
            opportunityId: {
                isReference: true,
                propertyName: "opportunityId",
                workflowNodeReferenceId: OPPORTUNITY_LOADER_DELEGATE_ID,
            },
            stageId: { value: formState.stage.id, isReference: false },
        },
    };
};
export const CHANGE_STAGE_GET_FORM_STATE = (criteria) => __awaiter(void 0, void 0, void 0, function* () {
    return {
        stage: yield StageService.get(criteria.stageId.value),
    };
});
const ChangeStageWorkflowNodeDefinitionForm = ({ name, pipelineId, }) => {
    return (_jsx(_Fragment, { children: _jsx(SearchField, { name: name + ".stage", label: "Stage", required: true, as: (provided) => (_jsx(StageSearch, Object.assign({ pipelineIds: [pipelineId] }, provided))) }) }));
};
export default ChangeStageWorkflowNodeDefinitionForm;
